import { render, staticRenderFns } from "./theaterManagement.vue?vue&type=template&id=55c8d3b2&scoped=true&"
import script from "./theaterManagement.vue?vue&type=script&lang=js&"
export * from "./theaterManagement.vue?vue&type=script&lang=js&"
import style0 from "./theaterManagement.vue?vue&type=style&index=0&id=55c8d3b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c8d3b2",
  null
  
)

export default component.exports